<template>
  <div class="fixed z-40 bg-deliYellow h-fit py-1 w-full">
    <!-- Definição do elemento de áudio -->
    <audio ref="audioPlayer" src="https://s3.radio.co/sdb4cf3826/listen">
      Your browser does not support the audio element.
    </audio>

    <div class="flex items-center px-2">
      <!-- Ícone de Play/Stop -->
      <img
        id="playerId"
        class="mr-2 cursor-pointer"
        @click="toggleAudio()"
        :src="
          isPlaying
            ? require('@/assets/img/stopped-icon.svg')
            : require('@/assets/img/playing-icon.svg')
        "
        alt="Play/Pause Icon"
      />

      <!-- Contêiner para o conteúdo -->
      <div class="text-center text-2xl lg:w-full">
        <div class="relative flex overflow-hidden">
          <div
            class="animate-marquee whitespace-nowrap font-[DashDigital] flex gap-2 w-96"
          >
            <!-- https://radio.co/api -->
            <div
              class="radioplayer"
              data-src="http://streaming.radio.co/sdb4cf3826/listen"
              data-playbutton="false"
              data-volumeslider="false"
              data-elapsedtime="false"
              data-nowplaying="true"
              data-showplayer="false"
              data-albumArtwork="true"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PlayerComponent",
  data() {
    return {
      isPlaying: false, // Controle se o áudio está tocando
      player: null,
      radioArtwork: null,
      artistaOuOutro: "",
    };
  },
  async mounted() {
    try {
      const response = await this.axios.get(
        "https://public.radio.co/api/v2/sdb4cf3826/track/current"
      );
      this.radioArtwork = response.data.data.artwork_urls.standard;
    } catch (error) {
      console.error(error);
    }

    //initialise the plugin with the element to the reference variable of 'player'
    this.player = $(".radioplayer").radiocoPlayer();

    $("#playerId").on("click", () => {
      console.log(this.player);
      // this.player.playToggle();
    });

    this.player.event("audioLoaded", (info) => {
      $(".radioco-nowPlaying")[0].innerText = `${
        $(".radioco-nowPlaying")[0].innerText
      }`;
      $(".status span").html("Loaded");
    });

    this.player.event("audioPlay", (e) => {
      $(".status span").html(
        "Playing at " +
          this.player.getTime() +
          ' seconds<br />artwork: <a href="' +
          this.player.getArtwork(500, 500, 75) +
          '" target="_blank">' +
          this.player.getArtwork(500, 500, 75) +
          "</a>"
      );
    });

    this.player.event("audioPause", (e) => {
      $(".status span").html("Paused at " + this.player.getTime() + " seconds");
    });

    this.player.event("timeUpdate", (e) => {
      console.log(e);
      $(".seconds").html(e.newTime);
    });

    this.player.event("songChanged", (e) => {
      $(".radioco-nowPlaying")[0].innerText = `${
        $(".radioco-nowPlaying")[0].innerText
      }`;
      // console.log('changed');
    });
  },
  methods: {
    getToday() {
      const date = new Date();
      const month = date.getMonth() + 1; // Meses começam em 0, então adicionamos 1
      const day = date.getDate(); // Obtém o dia
      const year = date.getFullYear() % 100; // Obtém os últimos dois dígitos do ano

      return `${day}/${month}/${year}`;
    },
    toggleAudio() {
      const audio = this.$refs.audioPlayer; // Referência ao elemento de áudio

      if (this.isPlaying) {
        audio.pause(); // Pausar o áudio se estiver tocando
      } else {
        audio.play(); // Tocar o áudio se não estiver tocando
      }

      this.isPlaying = !this.isPlaying; // Alterna o estado de play/pause
    },
  },
};
</script>
